<div [class.loading-overlay]="hasOverlay" class="loading-container">
  <div class="spinner"></div>
  <p class="h5">Carregando...</p>
</div>
